import { useContext } from 'react';
import AnalyticsContext from './AnalyticsContext';

// React hook for using Analytics
export const useAnalytics = () => {
  return useContext(AnalyticsContext);
};
